<template>
  <div class="container mt-5">
    <div class="row mb-4">
      <div class="col-sm-12">
        <span class="sub-title fs-4">G1 - Platform Specifications</span>
        <a
          class="view-link float-end"
          target="_blank"
          href="https://resourcesapi.taranawireless.com/doc/g1"
        >
          <font-awesome-icon :icon="['fas', 'download']" /> Download Complete
          Data Sheet
        </a>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <table class="table table-striped" id="specs_table">
          <tbody>
            <tr
              v-for="(row, index) in specsData"
              :key="index"
              :rowspan="row.data.length"
            >
              <td class="card-text" width="25%">
                {{ row.name }}
                <span class="text-sm" v-if="row.subtext"
                  ><br />{{ row.subtext }}</span
                >
              </td>
              <td width="75%">
                <table width="100%">
                  <tr
                    class="card-text"
                    v-for="(specdetails, index) in row.data"
                  >
                    <td
                      width="50%"
                      class="align-top"
                      v-html="$sanitize(specdetails.specs)"
                    ></td>
                    <td
                      width="50%"
                      class="align-top"
                      v-html="$sanitize(specdetails.description)"
                    ></td>
                  </tr>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-md-12" v-if="legendsList.length">
        <div v-for="(legend, index) in legendsList" :key="index">
          <div class="card-text" v-html="$sanitize(legend.legend_text)"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    specsData: {
      type: Array,
    },
    legendsList: {
      type: Array,
    },
  },
  data() {
    return {};
  },
};
</script>
